import Vue from 'vue';
import VueRouter from 'vue-router';
import Indent from '@/modules/indents/indentsRoute';
import mdm from '@/modules/mdm/mdmRoute';
import Auth from './auth';
import ErrorPage from './error';
import Payment from './payment';
import tracking from './tracking';
import wallet from './wallet';
import PaymentsV2 from './payments-v2';
import map from './map';
import redirect from './redirect';
import reports from './report';
import planning from './planning';

Vue.use(VueRouter);

const routes = [...Auth, ...Indent, ...Payment, ...ErrorPage, ...wallet, ...tracking,
  ...map, ...PaymentsV2, ...redirect, ...reports, ...mdm, ...planning];

const router = new VueRouter({ mode: 'history', routes });

router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    if (to.path === '/') {
      const token = localStorage.getItem('tsm-transporter-token');
      if (token) {
        next({ path: '/' });
      } else {
        next({ path: '/login' });
      }
    } else {
      next({ path: '/page-not-found' });
    }
  } else {
    next();
  }
});

export default router;
